import { create } from 'zustand';
import { PERF, type QualityLevel } from '@config/constants';

interface PerfState {
  fps: number;
  gestureLatencyMs: number;
  memoryMb: number;
  quality: QualityLevel;

  setFps: (v: number) => void;
  setLatency: (ms: number) => void;
  setMemory: (mb: number) => void;
  setQuality: (q: QualityLevel) => void;
}

export const usePerfStore = create<PerfState>((set) => ({
  fps: 0,
  gestureLatencyMs: 0,
  memoryMb: 0,
  quality: PERF.DEFAULT_QUALITY,

  setFps: (fps) => set({ fps }),
  setLatency: (gestureLatencyMs) => set({ gestureLatencyMs }),
  setMemory: (memoryMb) => set({ memoryMb }),
  setQuality: (quality) => set({ quality }),
}));
